export default "__VITE_ASSET__B4P2g_Wu__"